export default function MySQL_DROPTABLE() {
  return (
    <div>
      <h2>MySQL_DROPTABLE</h2>    </div>
  );
}